import React from 'react';
export const OverflowContext = /*#__PURE__*/React.createContext(null);